import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { createStore, Provider as JotaiProvider, useAtomValue } from "jotai";

import { ReactNode, useEffect, useMemo } from "react";

import { BrowserRouter } from "react-router-dom";

import { Toaster } from "sileo";

import { getBasePath } from "../../shared/config/env";

import i18n from "../../shared/i18n";

import { languageAtom } from "../../shared/state/preferencesAtoms";

type AppProvidersProps = {
  children: ReactNode;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,

      staleTime: 60_000,

      retry: 1,
    },

    mutations: {
      retry: 0,
    },
  },
});

const AppProviders = ({ children }: AppProvidersProps) => {
  const store = useMemo(() => createStore(), []);

  const basePath = getBasePath();

  return (
    <BrowserRouter basename={basePath}>
      <JotaiProvider store={store}>
        <LanguageEffect />
        <Toaster
          position="bottom-right"
          options={{
            fill: "#18181b",

            styles: {
              title: "color: #ffffff",

              description: "color: #ffffff",
            },
          }}
        />
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </JotaiProvider>
    </BrowserRouter>
  );
};

export default AppProviders;

const LanguageEffect = () => {
  const language = useAtomValue(languageAtom);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = language;
    }

    // Update i18n runtime language to match preference

    i18n.changeLanguage(language).catch(() => {
      // ignore errors on language switching
    });
  }, [language]);

  return null;
};
